module.exports = __webpack_public_path__ + "img/wz14.fe8deb6e.png";